module.exports = __webpack_public_path__ + "static/media/info_black.ff9aa0b5.svg";